import React from 'react';
import { FadeIn } from './FadeIn';
export function CollectionSection() {
  const tomos = [{
    emoji: '📘',
    title: 'TOMO I: Manual de Logística (6:30)',
    description: 'La ingeniería detrás de tu domingo de cocina.'
  }, {
    emoji: '📕',
    title: 'TOMO II: El Manifiesto del Sabor',
    description: '50 recetas diseñadas para no perder textura al congelar.'
  }, {
    emoji: '📗',
    title: 'TOMO III: Ingeniería de Compras',
    description: 'Comprá por volumen y bajá tus costos un 40%.'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-34">
      <FadeIn data-id="element-35">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-6 md:mb-10" data-id="element-36">
          LA COLECCIÓN COMPLETA
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-37">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={0.2 * index} className="bg-white p-5 md:p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full transform transition duration-300 hover:-translate-y-2" data-id="element-38">
            <div className="text-3xl md:text-5xl mb-3 md:mb-6" data-id="element-39">
              {tomo.emoji}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-40">
              {tomo.title}
            </h3>
            <p className="text-gray-600 text-lg flex-grow" data-id="element-41">
              {tomo.description}
            </p>
          </FadeIn>)}
      </div>
    </section>;
}